import React, { ReactNode } from "react";
import Colors from "../ui-kit/colors";

export const replaceMarkup = ({
  text,
  replace,
}: {
  text: string;
  replace: {
    match: string;
    tag: keyof JSX.IntrinsicElements;
    getProps: (part: string) => Record<string, any>;
  }[];
}): ReactNode => {
  const current = replace[0];

  if (!current) {
    return text;
  }

  const parts = text.split(`[${current.match}]`);

  return parts.map((part, index) => {
    if (index % 2 === 0) {
      return replaceMarkup({ text: part, replace: replace.slice(1) });
    }

    const Tag = current.tag;
    const props = current.getProps(part);

    return React.createElement(
      Tag,
      { key: part, ...props },
      replaceMarkup({ text: part, replace: replace.slice(1) })
    );
  });
};

export const replaceCommonMarkup = (text: string): ReactNode => {
  return replaceMarkup({
    text,
    replace: [
      {
        match: "b",
        tag: "span",
        getProps: () => ({ style: { fontWeight: 500 } }),
      },
      {
        match: "nowrap",
        tag: "span",
        getProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
      {
        match: "email",
        tag: "a",
        getProps: (part) => ({
          href: `mailto:${part}`,
          style: { color: Colors.blue300 },
        }),
      },
    ],
  });
};
